export enum ModalReasonModel {
  SAVE = 'Save click',
  CANCEL = 'Close click',
  CLOSE = 'Cross click',
}
